import React, { memo, useCallback } from 'react'

import { Button, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, number, string } from 'prop-types'

import { MODEL_FEEDBACK_SCORES } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

function RatingRow({ criterion, label, hint, value = null, onChange }) {
  const t = useTranslation()
  const headingId = `model-feedback-${criterion}`

  const handleScoreClick = useCallback((event) => {
    onChange(criterion, Number(event.currentTarget.value))
  }, [criterion, onChange])

  return (
    <div className="model-feedback__row">
      <div id={headingId} className="model-feedback__row-heading">
        <span className="cgt-body-base-semibold model-feedback__row-label">{label}</span>
        <span className="cgt-caption model-feedback__row-hint">{hint}</span>
      </div>
      <div className="model-feedback__scale" role="group" aria-labelledby={headingId}>
        {MODEL_FEEDBACK_SCORES.map(score => (
          <Button
            key={score}
            type="secondary"
            size="small"
            actionType="button"
            value={score}
            aria-pressed={value === score}
            customClass={classnames('model-feedback__score', value === score && 'model-feedback__score--selected')}
            onClick={handleScoreClick}
          >
            {score}
          </Button>
        ))}
      </div>
      <div className="cgt-caption model-feedback__scale-labels" aria-hidden="true">
        <span>{t('viewer.modelFeedback.scale.poor')}</span>
        <span>{t('viewer.modelFeedback.scale.ok')}</span>
        <span>{t('viewer.modelFeedback.scale.great')}</span>
      </div>
    </div>
  )
}

RatingRow.propTypes = {
  criterion: string.isRequired,
  label: string.isRequired,
  hint: string.isRequired,
  value: number,
  onChange: func.isRequired,
}

export default memo(RatingRow)
